module.exports = __webpack_public_path__ + "img/reservation_image.465aa17e.jpg";